import { useEffect } from "react";
import PropTypes from "prop-types";
import qs from "qs";
import { useHistory, useLocation } from "react-router";
import { useSelector } from "react-redux";

import PageHelper from "../../../../../lib/PageHelper";
import { getLocale } from "../../../../../redux/modules/translations/selector";

import "../styles/default.scss";

const SHOW_INTERCOM_BUTTON_KEY = "showIntercomButton";
const BODY_CLASS_HIDE_INTERCOM_LAUNCHER = "hide-intercom-launcher";

function applyLauncherVisibility(hidden) {
  document.body.classList.toggle(BODY_CLASS_HIDE_INTERCOM_LAUNCHER, hidden);
}

function IntercomVisibilityProvider({ children = null }) {
  const history = useHistory();
  const location = useLocation();
  const locale = useSelector(getLocale);

  useEffect(() => {
    const searchParams = qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    });

    if (searchParams.showIntercomButton === "false") {
      sessionStorage.setItem(SHOW_INTERCOM_BUTTON_KEY, "false");

      const nextParams = { ...searchParams };
      delete nextParams.showIntercomButton;
      const nextSearch = qs.stringify(nextParams, { addQueryPrefix: true });
      history.replace({
        pathname: window.location.pathname,
        search: nextSearch || ""
      });
    }
  }, [history]);

  useEffect(() => {
    const sessionHidden =
      sessionStorage.getItem(SHOW_INTERCOM_BUTTON_KEY) === "false";
    const isAuthPage = PageHelper.getIsAuthPage(location, locale);

    applyLauncherVisibility(sessionHidden || isAuthPage);
  }, [location.pathname, locale]);

  return children;
}

IntercomVisibilityProvider.propTypes = {
  children: PropTypes.node
};

export default IntercomVisibilityProvider;
